const TickIcon = ({ className, fill }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0116 3.9717C13.2113 4.16237 13.2187 4.47886 13.028 4.67861L6.02802 12.0119C5.93506 12.1093 5.80677 12.1651 5.67215 12.1667C5.53754 12.1682 5.40798 12.1155 5.31279 12.0203L2.97945 9.68693C2.78419 9.49167 2.78419 9.17508 2.97945 8.97982C3.17472 8.78456 3.4913 8.78456 3.68656 8.97982L5.65802 10.9513L12.3047 3.98814C12.4953 3.78839 12.8118 3.78103 13.0116 3.9717Z"
        fill={fill || "white"}
      />
    </svg>
  );
};

export default TickIcon;
